export const STAGE = {
  LOGIN: 'LOGIN',
  RESET_PASSWORD: 'RESET_PASSWORD',
  REGISTRATION: 'REGISTRATION',
  EMAIL_VERIFICATION_SENT: 'EMAIL_VERIFICATION_SENT',
};
